export default __webpack_public_path__ + "static/media/Front Small Pic.e0d2440f.png";